import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-envio',
  templateUrl: './envio.component.html',
  styleUrls: ['./envio.component.scss']
})

export class EnvioComponent implements OnInit {

  formGroup: FormGroup;

  @Input() data: any;

  @Output() validacao = new EventEmitter();
  @Output() enviaDados = new EventEmitter();

  constructor(
    private formBuilder: FormBuilder
  ) {
    this.carregarFormGroup();
  }

  ngOnInit() {
    window.scroll(0, -1);
  }

  carregarFormGroup() {
    this.formGroup = this.formBuilder.group(
      {
        formNome: new FormControl('', Validators.required),
        formEmail: new FormControl('', Validators.compose(
          [
            Validators.required,
            Validators.email
          ]
        )),
        formTelefone: new FormControl('', Validators.maxLength(18)),
        formNomeEmpresa: new FormControl(''),
        formCargo: new FormControl('')
      }
    );
  }

  validaForm() {
    if (this.formGroup.valid) {
      this.validacao.emit(true);
    } else {
      this.validacao.emit(false);
    }
    this.enviaDados.emit(this.formGroup);
  }

}
